import { SvrConn } from "../utils/axios/index";

/**
 *
 */
const getgraphicsprinc = async (AreaId) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/graphics/getgraphicsprinc",{AreaId});
    } catch (Error) {
      res = Error;
    }
    return res;
  };
/**
 * 
 */
const getparamsgraphics = async (AreaId) => {
  let res = {};
  try {
    res = await SvrConn.get("/api/graphics/getparamsgraphics");
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 * 
 */
  const getgraphicsprincs = async (AreaId, ServicioId) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/graphics/getgraphicsprincs", {AreaId, ServicioId});
    } catch (Error) {
      res = Error;
    }
    return res;
  };

  /**
   * 
   */
  const getgraphicshist = async (AreaId, periodoId, fecha, hora) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/graphics/getgraphicshist",{AreaId, periodoId, fecha, hora});
    } catch (Error) {
      res = Error;
    }
    return res;
  };
/**
 * 
 */
const getgraphicsfordate = async (AreaId, fechadesde, fechahasta) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/graphics/getgraphicsfordate",{AreaId, fechadesde, fechahasta});
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 * 
 */
const getgraphicsatenhora = async (AreaId, ServicioId, fechadesde, fechahasta) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/graphics/getgraphicsatenhora",{AreaId, ServicioId, fechadesde, fechahasta});
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 * 
 */
const getgraphicsatenmes = async (AreaId, mes, anio, ServicioId, UsuarioId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/graphics/getgraphicsatenmes",{AreaId, mes, anio, ServicioId, UsuarioId});
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 * 
 */
const getgraphicsatpromaten = async (AreaId, ServicioId, fechadesde, fechahasta) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/graphics/getgraphicsatpromaten",{AreaId, ServicioId, fechadesde, fechahasta});
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 * 
 */
const getgraphicspromespera = async (AreaId, ServicioId, fechadesde, fechahasta) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/graphics/getgraphicspromespera",{AreaId, ServicioId, fechadesde, fechahasta});
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 * 
 */
const getgraphicspromvisita = async (AreaId, ServicioId, fechadesde, fechahasta) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/graphics/getgraphicspromvisita",{AreaId, ServicioId, fechadesde, fechahasta});
  } catch (Error) {
    res = Error;
  }
  return res;
};

  export {
    getgraphicsprinc,
    getgraphicshist,
    getgraphicsprincs,
    getparamsgraphics,
    getgraphicsfordate,
    getgraphicsatenhora,
    getgraphicsatenmes,
    getgraphicsatpromaten,
    getgraphicspromespera,
    getgraphicspromvisita,
  };
  